import { OpaccStruct } from './classes/opacc.class.struct.js';

export const opaccStructPlugin = new OpaccStruct();